import { createFileRoute } from '@tanstack/react-router';
import { Configure2FAEmail } from '@mews-commander/modules/src/modules/auth';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_public/Home/Configure2FA/Email')({
    component: Configure2FAEmail,
    staticData: {
        title: TextKey.Configure2FA,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
